import WalletModule from './views/Module.vue';
// import Wallet from './views/Wallet.vue';
import WalletDeposit from './views/WalletDeposit.vue';
import WalletHistory from './views/WalletHistory.vue';
// import WalletHistoryDetail from './views/WalletHistoryDetail.vue';
import PaymentMethod from './components/PaymentMethod.vue';
import AddAccount from './views/AddAccount.vue';
import WalletWithdraw from './views/WalletWithdraw.vue';
import BankDetails from './views/BankDetails.vue';
import DepositAmount from './views/DepositAmount.vue';

const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [

      {
        path: 'wallet-deposit',
        name: 'wallet-deposit',
        component: DepositAmount,
      },
      {
        path: 'wallet-history',
        name: 'wallet-history',
        component: WalletHistory,
      },
      {
        path: 'payment-method',
        name: 'payment-method',
        component: PaymentMethod,
      },
      {
        path: 'deposit-payment-method',
        name: 'deposit-payment-method',
        component: WalletDeposit,
      },
        {
          path: 'add-account/:mode?',
          name: 'add-account',
          component: AddAccount,
          props: true
        },
      {
        path: 'wallet-withdraw/:newAccount?',
        name: 'wallet-withdraw',
        component: WalletWithdraw,
      },
      {
        path: 'bank-details',
        name: 'bank-details',
        component: BankDetails,
      }
    ],
}

export default WalletRoutes;